<template>
    <section v-if="loading === false" class="tabbed_content fluid_tabs cf">
        <div v-if="wins.length > 1" class="iwNav">
            <h4>You have multiple Prizes!</h4>
            <div v-if="selectedWin > 0" @click="prev"  class="button btn-primary multiIWButton">previous</div>
            <div v-if="selectedWin < wins.length - 1" @click="next" class="button btn-primary multiIWButton">Next</div>
        </div>

        <!-- <div>{{ selectedWin }}</div> -->
        
        <div v-for="win in wins" :key="win.uid">
            <div v-html="win.markup" v-if="selectedWin === win.uid"></div>
        </div>
    </section>
</template>

<script>
    import $ from 'jquery';
    import moment from "moment";
    import { inject } from 'vue';

    export default {
        data: function () {
            return {
                loading: true,
                mobileCashing: false,
                token: '',
                instantWin: '',
                message: '',
                image: '',
                wins:{},
                selectedWin: 0
            }
        },
        mounted: function () {
            this.getToken();
        },
        methods: {
            // ================================================================================================= //
            // Have this component grab all the iformation for each Instant Win. Then create a NEW component that has the markup, and the URL to grab the Static Content and inject the information. Import that new component into this one and loop it based on how many Instant Wins there are.
            prev() {
                if (this.selectedWin > 0) {
                    this.selectedWin = this.selectedWin -1;

                    if (this.wins[this.selectedWin].notification.Type === 2) {
                        setTimeout(() => {
                            this.getMessage();
                        }, 500);
                    }
                }
            },
            next() {
                if (this.selectedWin < this.wins.length-1) {
                    this.selectedWin = this.selectedWin + 1;

                    if (this.wins[this.selectedWin].notification.Type === 2) {
                        this.getMessage();
                    }
                }
            },
            getToken() {
                this.getAPItoken()
                .then((token) => {
                    this.token = token;
                    // console.log("Check here for value of the notification to determine which Static Content Element to get.");
                    // console.log(this.token);
                    // this.getTerms();
                    this.parseWins();
                });
            },
            parseWins() {
                let userInfo = this.$cookies.get('TokenInfo'),
                    notifications = userInfo.Notifications,
                    totalWins = [];

                for (let i = 0; i < notifications.length; i++) {
                    let type = parseInt(notifications[i].Type),
                        staticContentElementString;

                    switch(type) {
                        case 2:
                          //type 2 is the daily winner login instant win notification
                          staticContentElementString = 'mlr-instant-win';
                        break;
                        case 8:
                          //type 8 is the cash catch instant win notification
                          staticContentElementString = 'cc-instant-win';
                        break;
                        default:
                          staticContentElementString = 'mlr-instant-win';
                    }

                    totalWins.push({
                        "notification": notifications[i],
                        "static": staticContentElementString,
                        "uid": i
                    });

                    // this.getTerms(staticContentElementString);
                }

                this.wins = totalWins;

                for (let i = 0; i < this.wins.length; i++) {
                    this.getTerms(this.wins[i]);
                }
            },
            getTerms(key) {
                let instantWin = key,
                    wins = this.wins;

                // console.log(wins[instantWin.uid])

                let apiToken = this.token,
                    sku = this.getURLQuery('orderId'),
                    userInfo = this.$cookies.get('TokenInfo'),
                    // instantWinType = userInfo.Notifications[0].Type,
                    instantWinType = instantWin.Type,
                    url = process.env.VUE_APP_APIURL + '/1.0/Games/StaticContentElements/StaticContentElement/GetContentElementByKey?contentKey=';

                var staticContentElementString = instantWin.static;

                    url = url + staticContentElementString;
                    // console.log("The URL before FETCH");
                    // console.log(url);

                // let url = process.env.VUE_APP_APIURL + '/1.0/Games/StaticContentElements/StaticContentElement/GetContentElementByKey?contentKey=mlr-instant-win';
                    //need to determine which Static Content Element is needed and then fetch appropriately
                    // console.log("User Info HERE hopefully");
                    // console.log(userInfo);

                return fetch(url, {
                        method: 'GET',
                        // body: JSON.stringify(datCreds),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + apiToken,
                        },
                    }
                )
                .then((response) => response.json())
                .then((json) => {
                    // console.log("THE JSON FROM CALL");
                    // console.log(json);
                    // this.instantWin = json.data[0].centralContent;)
                    // console.log(json.data[0])
                    // console.log(json.data[0].centralContent)
                    wins[instantWin.uid].markup = json.data[0].centralContent;
                    // console.log(wins[instantWin.uid]);
                    this.wins = wins;
                    let button = document.getElementById('closeTC');
                })
                .then(() => {
                    if (instantWin.uid === this.wins.length - 1) {
                        this.loading = false;
                        setTimeout(() => {
                            this.getMessage(instantWin.uid);
                        }, 1000);

                    }
                })
                .catch((error) => {
                    // console.error("There was an error!", error);
                    return (this.errorMessage = error);
                });
            },
            getMessage(id) {
                console.log(this.wins)
                
                // let winner = this.$cookies.get('TokenInfo'),
                for (let i = 0; i < this.wins.length; i++) {
                    console.log(this.wins[i].uid)
                    if (this.wins[i].notification.Type == 2) {
                        let message = this.wins[i].notification.Message,
                            image = this.processImageURL(this.wins[i].notification.ImageURL);
                        
                        // console.log("WINNER NOTIFICATIONS");
                        // console.log(winner.Notifications);
                        console.log('Hitting Instant Win');

                        setTimeout(() => {
                            let injectMessage = document.getElementById('iwMessage'),
                                injectImage = document.getElementById('iwImage');

                            injectMessage.innerText = message;
                            injectImage.src = image;
                        }, 500);
                    }
                }
            },
            processImageURL(imgURL) {
                var newURL;
                if (imgURL[0] === '~') {
                    newURL = imgURL.substring(1);
                } else {
                    newURL = imgURL;
                }

                return newURL;
            }
		}
    };
</script>

<style lang="scss" scoped>
.iwNav {
    display: flex;
    justify-content: space-between;
    padding-right: 15px;
}
.multiIWButton {
    // max-width: 100px;
}
    /* #TransactionLogPage {
        height: 240px;
        margin: 15px 0;
        overflow-y: scroll;
    } */
</style>